import {
  callCallback,
  createContentRequest,
  stopLoadingShowError,
} from "../utils";
import * as tvx from "../lib/tvx-plugin-module.min";
import {
  MSXMenuRoot,
  MSXContentRoot,
  Tools,
  MSXContentItem,
  MSXContentPage,
} from "../lib/tvx-plugin-module.min";
import { res_home, res_serials } from "../static-res";
import { getPageCollections } from "../api/worker";
import { PagesEnum } from "../api/api-models";
import { createCollectionRow } from "./collections-row";

export function createSerialsRoot(callback: (data: any) => void): void {
  tvx.InteractionPlugin.stopLoading();
  getPageCollections(PagesEnum.SERIALS).then((serialsPage) => {
    if (serialsPage != null) {
      const collectionsWithMovies = serialsPage.collections;

      const serialsRoot: MSXContentRoot = {
        cache: true,
        restore: true,
        reuse: true,
        type: "list",
        headline: res_serials(),
        flag: "serials",
        important: true,
        pages: [],
      };
      collectionsWithMovies
        .sort((a, b) => a.position - b.position)
        .forEach((collectionWithFictions) => {
          serialsRoot.pages.push(createCollectionRow(collectionWithFictions));
        });
      callCallback(serialsRoot, callback);
    } else {
      console.log("error occured");

      stopLoadingShowError({}, callback);
    }
  });
}
